import { useMemo } from "react";
import { useAufgaben, useVorhaben } from "./daten";
import type { Aufgabe } from "./logik";

/* Ort einer Mitteilung in der Leiste und auf der Seite Mitteilungen (KOPFZEILE.md, Abschnitt 3.4): Der Kern kennt nur Links,
   das Modul sagt, wo die Aufgabe liegt. Für die Shell als Hook im Modul (Modul.mitteilungOrte). */

/** id der Aufgabe aus dem Link einer Mitteilung (/aufgaben/<id>, bei Kommentaren mit #k-<id>), sonst null */
export function aufgabeAusLink(link: string): string | null {
  const treffer = /^\/aufgaben\/([^/?#]+)/.exec(link);
  return treffer?.[1] ? decodeURIComponent(treffer[1]) : null;
}

/** Vorhaben vor Sprint: Das Vorhaben sagt mehr, der Sprint wechselt alle zwei Wochen. Ohne beides: null. */
export function ortDerAufgabe(a: Pick<Aufgabe, "vorhaben_id" | "sprint_name">, vorhaben: ReadonlyMap<string, string>): string | null {
  return (a.vorhaben_id ? vorhaben.get(a.vorhaben_id) : undefined) ?? a.sprint_name ?? null;
}

/** Je Link auf eine sichtbare Aufgabe ihr Ort. Nutzt die Listen, die die App ohnehin lädt (Aufgaben, Vorhaben). */
export function useMitteilungOrte(links: readonly string[]): ReadonlyMap<string, string> {
  const aufgaben = useAufgaben();
  const vorhaben = useVorhaben();
  return useMemo(() => {
    const namen = new Map((vorhaben.data ?? []).map((v) => [v.id, v.name]));
    const nachId = new Map((aufgaben.data ?? []).map((a) => [a.id, a]));
    const orte = new Map<string, string>();
    for (const link of links) {
      const id = aufgabeAusLink(link);
      const a = id ? nachId.get(id) : undefined;
      const ort = a ? ortDerAufgabe(a, namen) : null;
      if (ort) orte.set(link, ort);
    }
    return orte;
  }, [links, aufgaben.data, vorhaben.data]);
}
